
import goBackWithFallback from '@util/goBackWithFallback';
import Vue from "vue";
import { Component, Prop } from 'vue-property-decorator';
import BackIcon from '@components/icons/icon-back.svg';
import NextIcon from '@components/icons/icon-next.svg';
import CheckIcon from '@components/icons/icon-check.svg';
import { RouterFrom } from '@router/Routes';
import { Location, RawLocation } from 'vue-router';
import { namespace } from 'vuex-class';

const RouterModule = namespace('Router');

@Component({
  name: 'AppTripHeader',
  components: {
    BackIcon,
    NextIcon,
    CheckIcon
  }
})
export default class AppTripHeader extends Vue {
  @Prop()
  private title: string;

  @Prop({ default: false })
  private previousDisabled: boolean;

  @Prop({ default: false })
  private nextDisabled: boolean;

  @Prop({ default: false })
  private fullscreen: boolean;

  @Prop({ default: false })
  private editMode: boolean;

  @Prop({ default: false })
  private errorExists: boolean;

  @Prop({ default: '' })
  private backConfirmMessage: string; //'' = no confirmation modal

  @Prop()
  private backLocation: Location;

  @Prop({ default: false })
  private loading: boolean;

  @RouterModule.State('from')
  private from: RouterFrom;

  private handleClick() {
    if (this.fullscreen || !this.backConfirmMessage || window.confirm(this.backConfirmMessage)) {
      goBackWithFallback(this.$router, !!this.from.name, this.backLocation);
    }
  }
}
